import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { RestService, CommonService, UserService, DocumentsService } from '../../services/common';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DocumentSubType, UserSubType } from '../../../appconfig';
import { AddressDetailComponent } from '../address-detail/address-detail.component';
import { environment } from '../../../environments/environment';
import { IconList } from '../../../iconlist';
import { ToasterService } from '../../services/common/toaster.service';

declare const $: any;
@Component({
  selector: 'app-name-contact',
  templateUrl: './name-contact.component.html',
  styleUrl: './name-contact.component.scss'
})
export class NameContactComponent implements OnInit {
  @Input() customerData: any;
  @Input() userData: any;
  @Input() changeModelStatus: any;
  @Output() edituserPanel = new EventEmitter<any>();

  dummyDataUrl: string = '../../../assets/dummydb/';
  selectedRelationInitial: string = '';
  relationNameLabel: string = 'Relation Name';
  form!: FormGroup;
  Submitted = false;
  subTypeId: any = UserSubType.Client;
  showAdressModal: boolean = false;
  isCurrentAddress: boolean = false;
  genders: any[] = [];
  selectedGender!: number;
  religions: any[] = [];
  communityList: any[] = [];
  @ViewChild(AddressDetailComponent) address!: AddressDetailComponent;
  nameandContactDetailsRequest: any;
  nameContactData: any;
  documentId: any;
  profilePicData: any = null;

  constructor(private commonService: CommonService, private api: RestService,
    private formBuilder: FormBuilder,private toasterService:ToasterService, private userService: UserService, private documentService: DocumentsService) {
  }

  ngOnInit() {
    this.nameContactData = this.customerData;
    $('.aadhar').attr('disabled', 'disabled');
    this.getRelationInitial();
    this.initiateForm();
    this.getReligion();
    this.setUserData();
    this.setNameandContactData();
    this.getInitials();
    this.getGenders();
    this.onRelationInitialChange();
    this.getCurrentUserProfilePic();
  }
  setNameandContactData() {
    if (this.customerData) {
      this.form.patchValue({
        id: this.nameContactData?.id,
        relationInitialsId: this.nameContactData?.relationInitial?.id,
        nameInitial: this.nameContactData?.id,
        fatherHusbandName: this.nameContactData?.fatherHusbandName,
        name: this.nameContactData?.firstName + ' ' + this.nameContactData?.lastName,
        contactNo: this.nameContactData?.primaryPhoneNo,
        email: this.nameContactData?.email,
        pancardNo: this.nameContactData?.panCardNo,
        religionId: this.nameContactData?.community?.religionId,
        aadharNumber: this.nameContactData?.aadharNumber,
        communityId: this.nameContactData?.community?.id,
        nameInitialsId: this.nameContactData?.nameInitial?.id,
        gender: this.nameContactData?.gender
      });

      if (this.nameContactData?.community?.religionId != undefined) {
        this.getCommnunity();
      }
    }
  }

  //initiating the name and contact form with validation
  initiateForm() {
    this.form = this.formBuilder.group({
      id: [0],
      relationInitialsId: ['', [Validators.required]],
      nameInitial: ['', [Validators.required]],
      fatherHusbandName: ['', [Validators.required]],
      name: ['', [Validators.required]],
      contactNo: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      pancardNo: ['', [Validators.required]],
      religionId: [''],
      aadharNumber: [''],
      communityId: [''],
      nameInitialsId: ['', [Validators.required]],
      gender: ['', [Validators.required]]
    });
  }


  //hardcoded name initials
  nameInitials: any[] = [];
  /**
   * returns the form control after
   */
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  //opening a modal
  openModal(): void {
    this.showAdressModal = true;
  }

  getGenders() {
    this.genders = this.commonService.getGenders().result;

  }

  //getting realtionInitial using get api
  getRelationInitial() {
    let localUrl: string = this.commonService?.setDataUrl('name-initial?type=relation', this.dummyDataUrl + 'initial.json');
    this.api.getData(localUrl).subscribe((res) => {
      this.initials = res.result;
    });
    let initial = this.initials.find(
      (initial: any) => initial?.id == this.form?.value?.relationInitialsId
    );
    //when S/O & D/O selected then label should be Father Name
    if (initial?.name.toLowerCase() == 's/o' || initial?.name.toLowerCase() == 'd/o') {
      this.relationNameLabel = "Father Name";
    }
    //when W/O selecgted then label should be Husband Name
    else if (initial?.name.toLowerCase() == "w/o") {
      this.relationNameLabel = "Husband Name";
    }
  }

  initials: any[] = [];

  /**
   * method used to change the label of Relation name on behalf of relationInitialsId
   */
  onRelationInitialChange() {
    let initial = this.initials.find(
      (initial: any) => initial?.id == this.form?.value?.relationInitialsId
    );
    //when S/O & D/O selected then label should be Father Name
    if (initial?.name.toLowerCase() == 'S/o'.toLowerCase() || initial?.name.toLowerCase() == 'D/o'.toLowerCase()) {
      this.relationNameLabel = "Father Name";
    }
    //when W/O selecgted then label should be Husband Name
    else if (initial?.name.toLowerCase() == "W/o".toLowerCase()) {
      this.relationNameLabel = "Husband Name";
    }
  }

  /**
   * use to close the modal
   */
  close() {
    this.showAdressModal = false;
    this.form.controls['address'].setValue(this.commonService?.address);
    this.edituserPanel.emit({
      "showEditprofilePanel": false
    });
  }

  /**
   * method use to update user details using POST or PUT API
   * @returns when form is invalid then it returs to previous stage
   */
  onSubmit() {
    this.Submitted = true;
    if (this.form?.invalid) {
      return;
    } else {
      var data = this.form?.value
      var name = this.form?.value?.name.split(' ');
      if (data?.id > 0) {
        this.nameandContactDetailsRequest = {
          "id": this.nameContactData.id,
          "email": this.form?.value?.email,
          "nameInitialsId": this.form?.value?.nameInitialsId,
          "userSubTypeId": this.nameContactData.userSubType?.id,
          "primaryPhoneNo": this.form?.value?.contactNo,
          "fatherHusbandName": this.form?.value?.fatherHusbandName,
          "firstName": name[0],
          "lastName": name[1],
          "communityId": this.form?.value?.communityId,
          "relationInitialId": this.form?.value?.relationInitialsId,
          "loginAllowed": true,
          "isActive": true,
          "aadharNumber": this.form?.value?.aadharNumber,
          "panNumber": this.form?.value?.pancardNo,
          "gender": this.form?.value?.gender,
        };
        delete this.nameandContactDetailsRequest.dmid;
        this.userService.updateUser(this.nameContactData.id,this.nameandContactDetailsRequest).subscribe(() => {
          this.commonService.setUserProfile(this.nameandContactDetailsRequest);
          this.toasterService.showSuccess("User Details is updated Successfully");
          this.Submitted = false;
        });
      } else {
        this.nameandContactDetailsRequest = {
          "email": this.form?.value?.email,
          "nameInitialsId": this.form?.value?.nameInitialsId,
          "userSubTypeId": UserSubType.Client,
          "primaryPhoneNo": this.form?.value?.contactNo,
          "fatherHusbandName": this.form?.value?.fatherHusbandName,
          "firstName": name[0],
          "lastName": name[1],
          "communityId": this.form?.value?.communityId,
          "relationInitialsId": this.form?.value?.relationInitialsId,
          "loginAllowed": true,
          "isActive": true,
          // "aadharNumber" :this.form?.value?.aadharNumber,
          "panCardNo": this.form?.value?.pancardNo,

          "username": this.form?.value?.username,
          "secondaryPhoneNo": this.form?.value?.secondaryPhoneNo,
          "gender": this.form?.value?.gender,
          "password": "Mukul@123"
        };
        delete this.nameandContactDetailsRequest.dmid;
        this.api.postData('user/create', this.nameandContactDetailsRequest).subscribe(() => {
          this.commonService.setUserProfile(this.nameandContactDetailsRequest);
          this.toasterService.showSuccess("User Details is created Successfully");
          this.Submitted = false;
        });
      }
      this.nameandContactDetailsRequest.address1 = this.commonService?.address;
      this.nameandContactDetailsRequest.address2 = this.commonService?.address;
      this.nameandContactDetailsRequest.nameInitial = this.form?.value?.nameInitial;
    }

  }

  /**
   * method used to display permanent address if Current adrress is same as permanent address
   */
  setPermanantAddressAsCurrent() {
    if (this.isCurrentAddress === true) {
      this.form.controls['permanentAddress'].setValue(this.commonService?.address);
    }
    else {
      this.form.controls['permanentAddress'].setValue('');
    }

  }

  /**
   * Set the user data to show the data in input using common service
   */
  setUserData() {
    this.userService.getUserData().subscribe(data => {
      if (data) {
        this.form.controls['nameInitial'].setValue(data?.nameInitial);
        this.form.patchValue({
          email: data.email,
          name: data.firstName + ' ' + data.lastName,
          contactNo: data.primaryPhoneNo,
          fatherHusbandName: data.nameInitial?.name + '.' + data.fatherHusbandName,
          relationInitialsId: data?.relationInitial?.name,
          address: data.address1,
          permanentAddress: data.address2,
          nameInitialsId: data.nameInitial?.id,
          pancardNo: data.panCardNo,
          religionId: data.community?.religionId,
          communityId: data.community?.id,
          gender: data.gender,
        }
        );
        this.getCommnunity(true);
        this.nameandContactDetailsRequest = {
          "id": data?.id,
          "nameInitialsId": data?.nameInitial?.id,
          "firstName": data?.firstName,
          "lastName": data?.lastName,
          "username": null,
          "primaryPhoneNo": data?.primaryPhoneNo,
          "secondaryPhoneNo": null,
          "email": data?.email,
          "userSubTypeId": data?.userSubType?.id,
          "relationInitialId": data?.relationInitial?.id,
          "fatherHusbandName": data?.fatherHusbandName,
          "communityId": data?.community?.id,
          "loginAllowed": true,
          "dmid": 0,
          "isActive": true
        }
      }
    })
  }

  //getting name initials
  getInitials() {
    this.api.getData('name-initial?type=name').subscribe((res1) => {
      if (res1) {
        this.nameInitials = res1.result;
      }
    });
  }

  //event used to validate length of contact number on keyPress
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  /**
   * get religion using get api
   */
  getReligion() {
    this.api.getData('community/religion').subscribe((res) => {
      if (res) this.religions = res.result;
    })
  }

  /**
   * getting the community on the behalf of religionId
   * @param isLoad param used to load data before onLoad
   */
  getCommnunity(isLoad: boolean = false) {
    if (this.form?.value?.religionId == undefined) {
      return;
    }
    this.api.getData('community?religionId=' + this.form?.value?.religionId).subscribe((res) => {
      this.communityList = res?.result;
      //community lenght is 0 then list of community will be empty
      if (this.communityList?.length == 0) {
        this.form.controls['communityId'].setValue('');
      }
    })
  }
  imgUrl: any;
  paymentTypeCopy: any;
  paymentTypeCopyImg: any;
  displayDocumentFileDialogue: boolean = false;
  documentFileData: any;
  userProfilePicRecordExists: boolean = false
  clientImage: any = environment.assetsImagePath + IconList.DefaultUserProfilePic
  assetsImagePath = environment.assetsImagePath
  clientPicAddUpdateIcon: any = this.assetsImagePath + IconList.AddIcon
  picViewTitle: any = '';
  showclickedPic!: boolean;
  displayDocumentPicDialogue: boolean = false;
  /**
* @param event Take Image Set Base 64
*/
  uploadImage(event: any) {
    let file = event.target.files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imgUrl = reader.result
      this.paymentTypeCopy = this.imgUrl.split(',')[1];
      let data = this.imgUrl.split(',')[0];
      let data1 = data.split(';')[0];
      let data2 = data1.split(':')[1];
      let data3 = data2.split('/')[1];
      this.paymentTypeCopyImg = data3;
    }
  }

  /**
   * method used to set current config for profile pic
   * @param documentSubType which documentsubtype to be used from config
   */
  setCurrentFileConfig(documentSubType: any) {
    if (this.documentFileData) {
      this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType),
        this.documentFileData.showDocumentNumber = false;

    } else {
      this.documentFileData = {
        'picFor': this.commonService.addSpaceInCamelCase(documentSubType),
        "documentSubTypeId": DocumentSubType[documentSubType],
        'operationMode': this.userProfilePicRecordExists ? 'edit' : 'add',
        "isActive": true,
        "isVerified": false,
        "userId": this.customerData?.id
      }
    }
    this.displayDocumentFileDialogue = true
    this.documentFileData.documentNoHide = false
  }

  /**
 * Gets the profile pic of current user
 * @param userId user id whose profile pic details has to be fetched
 */
  getCurrentUserProfilePic() {
    //by defaults we assume file id does not exists
    if (this.nameContactData?.id != undefined) {
      this.documentService.getFilterDocument(this.nameContactData?.id).subscribe(userDocs => {

        if (userDocs?.result?.length > 0) {
          //Check if user has pic data already uploaded or not.
          this.profilePicData = userDocs?.result?.find((x: any) => x.documentSubTypeId == DocumentSubType.Photo)
          this.documentId = this.profilePicData?.documentId
          if (this.profilePicData?.documentId != undefined) {
            //if any profile pic already uploaded for current user then get the pic bytes else set default pic
            this.documentService.getDocumentBytesById(this.profilePicData?.documentId).subscribe((profilePicRes: any) => {
              //if we find the profile pic on cloude then it display it
              if (profilePicRes) {
                this.clientImage = this.commonService.BaseStringToNormalString(profilePicRes)
                this.clientPicAddUpdateIcon = environment.assetsImagePath + IconList.EditIcon
              }
              else {
                //If document id exists but somehow pic deleted (in any case) from cloud then it will sent the default pic
                //but operatonit mode will be edit not add as file id already exists
                this.setDefaultUserProilePic()
              }
            });
          }
        }
      });
    }
  }

  /**
   * method use to set default profile pic of user
   */
  setDefaultUserProilePic() {
    this.clientImage = this.assetsImagePath + IconList.DefaultUserProfilePic

    if (this.userProfilePicRecordExists)
      this.clientPicAddUpdateIcon = this.assetsImagePath + IconList.EditIcon
    else
      this.clientPicAddUpdateIcon = this.assetsImagePath + IconList.AddIcon
  }

  /**
* @param picTitle Camera Pic Title Set
* @param picFor
* @param index Camera Pic Value Indexing Multiple Show
*/
  setClickPicView(picTitle: any, picFor: any, index: number = -1) {
    this.picViewTitle = picTitle
    this.showclickedPic = true
  }

  /**
 *
 * @param receivedPicData Receives file from common document file control which is updated by user
 */
  receiveCurrentUserProfilePic(receivedPicData: any) {
    if (receivedPicData && receivedPicData?.documentFile) {
      // this.customerData.currentRecord.id = receivedPicData?.documentFile?.userId;
      receivedPicData.documentFile.documentId = this.documentId;
      this.saveDocumentFile(receivedPicData.documentFile)
      // this.clientImage = this.customerData?.clientPic;
      this.clientImage = receivedPicData?.documentFile?.documentByte;

      this.clientPicAddUpdateIcon = environment.assetsImagePath + IconList.EditIcon
    } else {
      this.clientImage = this.assetsImagePath + IconList.DefaultUserProfilePic
    }
    this.displayDocumentPicDialogue = false;
    this.displayDocumentFileDialogue = false;
  }

  /**
* Saves the currently uploaded file
* @param documentFileData byte data of file to be uploaded
*/
  saveDocumentFile(documentFileData: any) {
    //Save document (Photo) file
    this.documentService.saveDoucmentFile(documentFileData)
  }
}

